import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import { logout } from '../actions/user'
import { isProduction } from '../helpers'

import Book from './Book'
import User from './User'
import Client from './Client'
import Casting from './Casting'
import ListModel from './ListModel'
import ListRejected from './ListRejected'
import ListWaiting from './ListWaiting'
import ListCasting from './ListCasting'
import ListClients from './ListClients'
import ListPhotographer from './ListPhotographer'
import Permission from './Permission'
import Header from '../components/Header'
import Drawer from '../components/Drawer'
import MagicHelpers from './MagicHelpers'

const styles = theme => ({
  root: {
    overflowX: 'hidden',
  },
  container: {
    marginTop: 65,
    position: 'relative',
    width: '100vw',
    display: 'flex',
    overflow: 'hidden',
    height: 'calc(100vh - 65px)',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.25)',
    background: '-webkit-linear-gradient(45deg, #f5f5f5 30px, #f5f5f5 30px), -webkit-linear-gradient(135deg, transparent 30px, #f5f5f5 30px), -webkit-linear-gradient(225deg, #f5f5f5 30px, #f5f5f5 30px), -webkit-linear-gradient(315deg, transparent 30px, #f5f5f5 30px)',
  },
  containerWithoutHeader: {
    marginTop: 0,
    background: 'white',
  },
  contentOverflow: {
    flex: 1,
    height: '100%',
    overflowY: 'auto',
  },
  content: {
    maxWidth: 1260,
    margin: '0 auto',
    padding: theme.spacing(1),
  },
  fluid: {
    maxWidth: 'none',
  },
  hidden: {
    display: 'none',
  },
})

class Admin extends Component {
  /* LIFECYCLE */
  state = {
    drawerOpened: false,
  }


  /* METHODS */

  handleToggleDrawer = () => this.setState({ drawerOpened: !this.state.drawerOpened })


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      classes,
      profile,
      location,
    } = this.props
    const { drawerOpened } = this.state
    const isFluid = typeof window !== 'undefined' && window.location.href.includes('/book/')

    return (
      <Permission>
        <div className={classes.root}>
          <Header
            profile={profile}
            drawerOpened={drawerOpened}
            onLogout={this.props.logout}
            onToggleDrawer={this.handleToggleDrawer}
            className={classNames({ [classes.hidden]: isFluid })}
          />

          <div id="admin" className={classNames(classes.container, { [classes.containerWithoutHeader]: isFluid })}>
            <Drawer opened={drawerOpened} pathname={location.pathname} />

            <div className={classes.contentOverflow}>
              <main className={classNames(classes.content, { [classes.fluid]: isFluid })}>
                <Switch>
                  <Route exact path="/admin" component={ListWaiting} />
                  <Route exact path="/admin/rejected" component={ListRejected} />
                  <Route exact path="/admin/user/:id" component={User} />
                  <Route exact path="/admin/clients/:id" component={Client} />
                  <Route exact path="/admin/clients" component={ListClients} />
                  <Route exact path="/admin/models" component={ListModel} />
                  <Route exact path="/admin/castings" component={ListCasting} />
                  <Route exact path="/admin/castings/:id" component={Casting} />
                  <Route exact path="/admin/photographers" component={ListPhotographer} />
                  <Route exact path="/admin/magic" component={MagicHelpers} />
                  <Route exact path="/admin/book/:id" component={Book} />
                </Switch>
              </main>
            </div>
          </div>
        </div>
      </Permission>
    )
  }
}


Admin.propTypes = {
  user: PropTypes.object,
  profile: PropTypes.object,
  casting: PropTypes.object,
  logout: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
}


const mapStateToProps = state => ({
  user: state.admin.user,
  profile: state.user.data,
  casting: state.castings.casting,
})


export default connect(mapStateToProps, {
  logout,
})(withStyles(styles)(Admin))
